import api from '../../api/_inventaire'

const state = () => ({
    inventaires: [],
    inventaire: {},
    resultats: [],
    produitsStock: [],
})

// getters
const getters = {
    inventaires: (state) => state.inventaires,
    inventaire: (state) => state.inventaire,
    resultats: (state) => state.resultats,
    produitsStock: (state) => state.produitsStock,
}

// actions
const actions = {
    getInventaire({commit}, id) {
        return api.getInventaire(id).then(response => {
            commit('SET_INVENTAIRE', response)
            commit('SET_RESULTATS', response.resultats || [])
            return response
        })
    },

    getInventaires({commit}, params = {}) {
        return api.inventaires(params).then(response => {
            commit('SET_INVENTAIRES', response)
            return response
        })
    },

    saveInventaire({commit}, data) {
        return api.saveInventaire(data).then(response => {
            commit('SET_INVENTAIRE', response?.inventaire || response)
            return response
        })
    },

    demanderInventaire({commit}, data) {
        return api.demanderInventaire(data).then(response => {
            commit('SET_INVENTAIRE', response?.inventaire || response)
            return response
        })
    },

    getProduitsStock({commit}, stockId) {
        return api.produitsStock(stockId).then(response => {
            commit('SET_PRODUITS_STOCK', response || [])
            return response
        })
    },

    updateInventaireResultats({commit}, {id, resultats}) {
        return api.updateResultats(id, {resultats}).then(response => {
            if (response?.inventaire) {
                commit('SET_INVENTAIRE', response.inventaire)
                commit('SET_RESULTATS', response.inventaire.resultats || [])
            }
            return response
        })
    },

    soumettreInventaire({commit}, { id, utilisateur_id }) {
        return api.soumettreInventaire(id, utilisateur_id).then(response => {
            commit('SET_INVENTAIRE', response?.inventaire || response)
            return response
        })
    },

    autoriserCorrectionInventaire({commit}, id) {
        return api.autoriserCorrection(id).then(response => {
            commit('SET_INVENTAIRE', response?.inventaire || response)
            return response
        })
    },

    saveInventaireObservation({commit}, {id, observation_admin}) {
        return api.saveObservation(id, {observation_admin}).then(response => {
            commit('SET_INVENTAIRE', response?.inventaire || response)
            return response
        })
    },

    retablirInventaire({commit}, id) {
        return api.retablirInventaire(id).then(response => {
            commit('SET_INVENTAIRE', response?.inventaire || response)
            return response
        })
    },

    deleteInventaire({dispatch}, id) {
        return new Promise((resolve, reject) => {
            api.deleteInventaire(id).then(
                response => {
                    dispatch
                    resolve(response);
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

// mutations
const mutations = {
    SET_INVENTAIRES(state, inventaires) {
        state.inventaires = inventaires
    },

    SET_INVENTAIRE(state, inventaire) {
        state.inventaire = inventaire
    },

    SET_RESULTATS(state, resultats) {
        state.resultats = resultats
    },

    SET_PRODUITS_STOCK(state, produits) {
        state.produitsStock = produits
    },
}

export default {
  state,
  getters,
  actions,
  mutations
}
